import React from "react";
export var EpiContext = React.createContext({ isDebug: false, isEditable: false });
